import back_arrow from "../assets/backarrow.svg";
import strengths from "../assets/strengths.svg";
import weaknesses from "../assets/weaknesses.svg"
import team_variance from "../assets/variance.svg"
import stakeholder_variance from "../assets/stakeholder_variance.svg"
import strengths_light from "../assets/strengths_light.svg"
import weaknesses_light from "../assets/weaknesses_light.svg"
import team_variance_light from "../assets/variance_light.svg"
import stakeholder_variance_light from "../assets/stakeholder_variance_light.svg"
import SummaryGraphical from "../components/SummaryGraphical";
import SummaryTabular from "../components/SummaryTabular";
import SummaryProgramme from "../components/SummaryProgramme";
import {useEffect, useState} from "react";
import CoachCommentaryContainer from "../components/CoachCommentaryContainer";
import coaching from "../api/protected/coaching";


const SummaryTop5s = (props) => {

    const surveyData = props.surveyData;
    const generatingReport = props.generatingReport;
    const coachingSpacer = props.coachingSpacer;

    const subscription = props.subscription;

    const cardType = props.cardType;
    const [cardData, setCardData] = useState();

    useEffect(() => {
        if (!surveyData || cardType === undefined) return;
        setCardData(surveyData.summary_aggregates[cardType]);
    }, [surveyData, cardType]);


    useEffect(() => {
        window.scrollTo(0,0);
    }, [])

    const handleBackClick = () => {
        props.back(cardType);
    }

    const getTitle = () => {
        switch (cardType) {
            case 0: return "Strengths";
            case 1: return "Weaknesses";
            case 2: return "Team Variance";
            case 3: return "Stakeholder Variance";
            default: return "Summary";
        }
    }

    return (
        <>
            <div className="link" onClick={handleBackClick} style={{display: generatingReport ? "none" : null}}>
                <img className={"back-arrow-classname"} src={back_arrow} alt={"Back Arrow"}/>
            </div>
            <div className="summary-title"
                 style={{marginLeft: generatingReport ? "30px" : null, padding: generatingReport ? "unset" : null}}>
                {getTitle()}
            </div>
            <div className="summary-top-5-container">
                <div className="summary-top-5-controls-container" style={{display: generatingReport ? "none" : null}}>
                    <div className={`summary-top-5-control-button link ${cardType === 0 ? "active" : ""}`}
                         onClick={() => props.switchMenu(0)}>
                        <img src={cardType === 0 ? strengths_light : strengths} alt="Strengths"/>
                    </div>
                    <div className={`summary-top-5-control-button link ${cardType === 1 ? "active" : ""}`}
                         onClick={() => props.switchMenu(1)}>
                        <img src={cardType === 1 ? weaknesses_light : weaknesses} alt="Weaknesses"/>
                    </div>
                    <div className={`summary-top-5-control-button link ${cardType === 2 ? "active" : ""}`}
                         onClick={() => props.switchMenu(2)}>
                        <img src={cardType === 2 ? team_variance_light : team_variance} alt="Team Varaince"/>
                    </div>
                    <div className={`summary-top-5-control-button link ${cardType === 3 ? "active" : ""}`}
                         onClick={() => props.switchMenu(3)}>
                        <img src={cardType === 3 ? stakeholder_variance_light : stakeholder_variance} alt="Stakeholder Variance"/>
                    </div>
                </div>
                <div className="summary-top-5-body-container" style={{width: generatingReport ? "100%" : null}}>
                    {!props.hideGraphical ?
                        <>
                            <SummaryGraphical cardData={cardData} generatingReport={generatingReport} subscription={subscription} />
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`top-5-graphical-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                    {!props.hideTabular ?
                        <>
                            <SummaryTabular cardData={cardData} cardType={cardType} surveyData={surveyData}
                                            origin={"top5s"}
                                            showQuestions={true}
                                            seeQuestions={props.seeQuestions} generatingReport={generatingReport}
                                            subscription={subscription} />
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`top-5-tabular-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                    {!props.hideProgramme ?
                        <>
                            <div className="pdf-spacer" style={{height: coachingSpacer, display: generatingReport ? "block" : "none"}}/>
                            <SummaryProgramme programmes={surveyData?.summary_aggregates[cardType]?.coaching_programme}
                                              cardType={cardType} generatingReport={generatingReport}
                                              hideExercises={props.hideExercise}/>
                            <CoachCommentaryContainer context_id={props.surveyID} generatingReport={generatingReport}
                                                      section_id={`top-5-programme-${cardType}`} demo={props.demo}
                                                      subscription={subscription}/>
                        </> : null
                    }
                </div>
            </div>
        </>
    )
}

export default SummaryTop5s